<h3 mat-dialog-title>Artikelliste auswählen</h3>
<mat-dialog-content>
    <kiene-autocomplete
        (elementSelected)="selectListe($event)"
        [apiUrl]="'artikelliste/'"
        [displayFields]="['listenname']"
        [placeholder]="'Artikelliste'"
    ></kiene-autocomplete>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button color="primary" (click)="cancel()">Abbrechen</button>
</mat-dialog-actions>
